import React from "react";
var __jsx = React.createElement;
import Skeleton from '../../atoms/Skeleton';
import YextRichText from '../../atoms/YextRichText';
function RichText(_ref) {
  var _yextInfo$fieldId, _yextInfo$entities, _yextInfo$entities$0$;
  var isLoading = _ref.isLoading,
    className = _ref.className,
    yextInfo = _ref.yextInfo,
    fieldId = _ref.fieldId,
    skeletonData = _ref.skeletonData;
  if (isLoading) {
    return __jsx(Skeleton, {
      className: skeletonData.className,
      width: skeletonData.width,
      height: skeletonData.height,
      type: skeletonData.type
    });
  }
  var fieldValue = (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$fieldId = yextInfo[fieldId]) === null || _yextInfo$fieldId === void 0 ? void 0 : _yextInfo$fieldId.json) || (yextInfo === null || yextInfo === void 0 ? void 0 : (_yextInfo$entities = yextInfo.entities) === null || _yextInfo$entities === void 0 ? void 0 : (_yextInfo$entities$0$ = _yextInfo$entities[0][fieldId]) === null || _yextInfo$entities$0$ === void 0 ? void 0 : _yextInfo$entities$0$.json);
  if (fieldValue) {
    return __jsx(YextRichText, {
      className: className,
      serializedAST: JSON.stringify(fieldValue)
    });
  }
}
export default RichText;